export const endPoints = {
  INDEX: '/website',
  WEBSITE: '/website/view',
  CRON: "/cron/update-all"
}